import { useState, useEffect } from 'react';
import axios from 'axios';
import './ManageProductTypes.css';

export default function ManageProductTypes() {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [productTypes, setProductTypes] = useState([]);
  const [newType, setNewType] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [editTypeId, setEditTypeId] = useState(null);
  const [editTypeName, setEditTypeName] = useState('');
  const typesPerPage = 5;

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    const res = await axios.get('https://spinelleapi.emedha.in/admin/product/api/categories');
    setCategories(res.data);
  };

  const fetchProductTypes = async (categoryId) => {
    const res = await axios.get(`https://spinelleapi.emedha.in/admin/product/api/categories/${categoryId}/types`);
    setProductTypes(res.data);
    setCurrentPage(1);
  };

  const handleCategorySelect = (e) => {
    setSelectedCategory(e.target.value);
    fetchProductTypes(e.target.value);
  };

  const addProductType = async () => {
    if (newType.trim() === '' || !selectedCategory) return;
    await axios.post(`https://spinelleapi.emedha.in/admin/product/api/categories/${selectedCategory}/types`, { name: newType });
    setNewType('');
    fetchProductTypes(selectedCategory);
  };

  const deleteProductType = async (typeId) => {
    await axios.delete(`https://spinelleapi.emedha.in/admin/product/api/types/${typeId}`);
    fetchProductTypes(selectedCategory);
  };

  const startEdit = (type) => {
    setEditTypeId(type.id);
    setEditTypeName(type.name);
  };

  const cancelEdit = () => {
    setEditTypeId(null);
    setEditTypeName('');
  };

  const updateProductType = async (typeId) => {
    if (editTypeName.trim() === '') return;
    await axios.put(`https://spinelleapi.emedha.in/admin/product/api/types/${typeId}`, { name: editTypeName });
    setEditTypeId(null);
    setEditTypeName('');
    fetchProductTypes(selectedCategory);
  };

  // Pagination Logic
  const indexOfLastType = currentPage * typesPerPage;
  const indexOfFirstType = indexOfLastType - typesPerPage;
  const currentTypes = productTypes.slice(indexOfFirstType, indexOfLastType);
  const totalPages = Math.ceil(productTypes.length / typesPerPage);

  return (
    <div className="manage-container">
      <h2>Manage Product Types</h2>
      <div className="form-group">
        <select onChange={handleCategorySelect} value={selectedCategory}>
          <option value="">Select Category</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>{cat.name}</option>
          ))}
        </select>
      </div>

      {selectedCategory && (
        <>
          <div className="form-group">
            <input
              type="text"
              placeholder="New Product Type"
              value={newType}
              onChange={(e) => setNewType(e.target.value)}
            />
            <button onClick={addProductType}>Add Type</button>
          </div>

          <div className="table-container">
            <table className="data-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Product Type</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentTypes.map((type, index) => (
                  <tr key={type.id}>
                    <td>{indexOfFirstType + index + 1}</td>
                    <td>
                      {editTypeId === type.id ? (
                        <input
                          type="text"
                          value={editTypeName}
                          onChange={(e) => setEditTypeName(e.target.value)}
                          autoFocus
                        />
                      ) : (
                        type.name
                      )}
                    </td>
                    <td>
                      {editTypeId === type.id ? (
                        <>
                          <button className="action-btn save" onClick={() => updateProductType(type.id)}>Save</button>
                          <button className="action-btn cancel" onClick={cancelEdit}>Cancel</button>
                        </>
                      ) : (
                        <>
                          <button className="action-btn edit" onClick={() => startEdit(type)}>Edit</button>
                          <button className="action-btn delete" onClick={() => deleteProductType(type.id)}>Delete</button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="pagination">
            {Array.from({ length: totalPages }, (_, i) => (
              <button
                key={i + 1}
                className={`page-btn ${currentPage === i + 1 ? 'active' : ''}`}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
